<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id="createNoRealTaskDialog1">
      <div class='row h-row-around-inputBox'>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.taskName')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" name="taskName" type="text" v-model="paramsOfNoRealTaskCreateDialog1.taskName">
            </div>
          </div>

          <div class='h-col-inputBox'>
            <div class="h-inputLit">{{$t('Pm.taskDescription')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" name="taskDepict" v-model="paramsOfNoRealTaskCreateDialog1.taskDepict">
            </div>
          </div>

          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.resourceType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist :dataSource='dataSourceOfNeType' :fields='fieldsOfNeType' v-model="paramsOfNoRealTaskCreateDialog1.neType"></ejs-dropdownlist>
            </div>
          </div>

          <div class='h-col-inputBox'>
            <div class="h-inputLit">{{$t('Pm.collectCycle')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist :dataSource='dataSourceOfSampleTime' :fields='fieldsOfSampleTime' v-model="paramsOfNoRealTaskCreateDialog1.sampleTime" :change="onSampleTimeChange"></ejs-dropdownlist>
            </div>
          </div>

          <div class='h-col-inputBox'>
            <div class="h-inputLit">{{$t('Pm.reportCycle')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist :dataSource='dataSourceOfReportTime' :fields='fieldsOfReportTime' v-model="paramsOfNoRealTaskCreateDialog1.reportTime"></ejs-dropdownlist>
            </div>
          </div>

          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.start_time')}}：</div>
            <ejs-datetimepicker :format='dateFormat' :change='validateOfCreateDialog1' name="startTime" :placeholder='$t("Pm.defaultNow")' :locale='locale' v-model='paramsOfNoRealTaskCreateDialog1.startTime'></ejs-datetimepicker>
          </div>

          <div class='h-col-inputBox'>
            <div class="h-inputLit">{{$t('Pm.end_time')}}：</div>
            <ejs-datetimepicker :format='dateFormat' :change='validateOfCreateDialog1' name="endTime" :placeholder='$t("Pm.defaultPermanent")' :locale='locale' :max='maxDateOfEndTime' v-model='paramsOfNoRealTaskCreateDialog1.endTime'></ejs-datetimepicker>
          </div>
        </div>

        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class="h-inputLit">{{$t('Pm.startTimeFrame')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist :dataSource='hourList' :fields='fieldsOfHour' v-model="paramsOfNoRealTaskCreateDialog1.startHour"></ejs-dropdownlist>
            </div>
          </div>

          <div class='h-col-inputBox'>
            <div class="h-inputLit">{{$t('Pm.endTimeFrame')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist :dataSource='hourList' :fields='fieldsOfHour' v-model="paramsOfNoRealTaskCreateDialog1.endHour"></ejs-dropdownlist>
            </div>
          </div>

          <div class='h-col-inputBox'>
            <div class="h-inputLit">{{$t('Pm.measurePlan')}}:</div>
            <ejs-radiobutton :label='$t("Pm.noPlan")' name="measurePlan" value="0" :checked='true' :change="changeOfMeasurePlan"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.weekPlan")' name="measurePlan" value="1" :change="changeOfMeasurePlan"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.monthPlan")' name="measurePlan" value="2" :change="changeOfMeasurePlan"></ejs-radiobutton>
          </div>

          <div class='h-col-inputBox' v-show="weekPlanShow">
            <div class="h-plan-week">
              <span v-for='(obj,index) in weekDayList' :key="obj.value" @click="weekPlanClick(obj.value,index)" :class="{'select': checkSelectOrNotForWeek(index)}">{{obj.name}}</span>
            </div>
          </div>
          <div class='h-col-inputBox' v-show="monthPlanShow">
            <div class="h-plan-month">
              <span v-for='(obj,index) in monthDayList' :key="obj.value" @click="monthPlanClick(obj.value,index)" :class="{'select': checkSelectOrNotForMonth(index)}">{{obj.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";

  export default {
    name: 'CreateNoRealTaskDialog1',
    data() {
      return {
        locale: localStorage.getItem('locale'),
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        maxDateOfEndTime: new Date(2100, 11, 31),
        paramsOfNoRealTaskCreateDialog1: {
          taskName: '',
          taskDepict: '',
          neType: 0,
          sampleTime: 900000,
          reportTime: 900000,
          startTime: new Date(),
          endTime: null,
          startHour: -1,
          endHour: -1,
          week: [],
          day: []
        },
        dataSourceOfNeType: [
        ],
        dataSourceOfSampleTime: [
          {cycle: `5${this.$t('Pm.minutes')}`, value: 300000},
          {cycle: `15${this.$t('Pm.minutes')}`, value: 900000},
          {cycle: `30${this.$t('Pm.minutes')}`, value: 1800000},
          {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
          {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
        ],
        dataSourceOfReportTime: [
          {cycle: `15${this.$t('Pm.minutes')}`, value: 900000},
          {cycle: `30${this.$t('Pm.minutes')}`, value: 1800000},
          {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
          {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
        ],
        fieldsOfNeType: {
          text: 'neTypeName',
          value: 'neTypeCode'
        },
        fieldsOfSampleTime: {
          text: 'cycle',
          value: 'value'
        },
        fieldsOfReportTime: {
          text: 'cycle',
          value: 'value'
        },
        hourList: [
          {text:this.$t('Pm.noSetting'), value: -1},
          {text:`1${this.$t('Pm.oClock')}`, value: 1},
          {text:`2${this.$t('Pm.oClock')}`, value: 2},
          {text:`3${this.$t('Pm.oClock')}`, value: 3},
          {text:`4${this.$t('Pm.oClock')}`, value: 4},
          {text:`5${this.$t('Pm.oClock')}`, value: 5},
          {text:`6${this.$t('Pm.oClock')}`, value: 6},
          {text:`7${this.$t('Pm.oClock')}`, value: 7},
          {text:`8${this.$t('Pm.oClock')}`, value: 8},
          {text:`9${this.$t('Pm.oClock')}`, value: 9},
          {text:`10${this.$t('Pm.oClock')}`, value: 10},
          {text:`11${this.$t('Pm.oClock')}`, value: 11},
          {text:`12${this.$t('Pm.oClock')}`, value: 12},
          {text:`13${this.$t('Pm.oClock')}`, value: 13},
          {text:`14${this.$t('Pm.oClock')}`, value: 14},
          {text:`15${this.$t('Pm.oClock')}`, value: 15},
          {text:`16${this.$t('Pm.oClock')}`, value: 16},
          {text:`17${this.$t('Pm.oClock')}`, value: 17},
          {text:`18${this.$t('Pm.oClock')}`, value: 18},
          {text:`19${this.$t('Pm.oClock')}`, value: 19},
          {text:`20${this.$t('Pm.oClock')}`, value: 20},
          {text:`21${this.$t('Pm.oClock')}`, value: 21},
          {text:`22${this.$t('Pm.oClock')}`, value: 22},
          {text:`23${this.$t('Pm.oClock')}`, value: 23},
          {text:`24${this.$t('Pm.oClock')}`, value: 24},
        ],
        fieldsOfHour:{
          text: 'text',
          value: 'value'
        },
        weekPlanShow: false,
        monthPlanShow: false,
        weekDayExistIndexList: [],
        weekDayExistValueList: [],
        monthDayExistIndexList: [],
        monthDayExistValueList: [],
        weekDayList: [
          {value: 1, name: this.$t('Pm.monday')},
          {value: 2, name: this.$t('Pm.tuesday')},
          {value: 3, name: this.$t('Pm.wednesday')},
          {value: 4, name: this.$t('Pm.thursday')},
          {value: 5, name: this.$t('Pm.friday')},
          {value: 6, name: this.$t('Pm.saturday')},
          {value: 0, name: this.$t('Pm.sunday')},
        ],
        monthDayList: [
          {value: 1, name: '01'},
          {value: 2, name: '02'},
          {value: 3, name: '03'},
          {value: 4, name: '04'},
          {value: 5, name: '05'},
          {value: 6, name: '06'},
          {value: 7, name: '07'},
          {value: 8, name: '08'},
          {value: 9, name: '09'},
          {value: 10, name: '10'},
          {value: 11, name: '11'},
          {value: 12, name: '12'},
          {value: 13, name: '13'},
          {value: 14, name: '14'},
          {value: 15, name: '15'},
          {value: 16, name: '16'},
          {value: 17, name: '17'},
          {value: 18, name: '18'},
          {value: 19, name: '19'},
          {value: 20, name: '20'},
          {value: 21, name: '21'},
          {value: 22, name: '22'},
          {value: 23, name: '23'},
          {value: 24, name: '24'},
          {value: 25, name: '25'},
          {value: 26, name: '26'},
          {value: 27, name: '27'},
          {value: 28, name: '28'},
          {value: 29, name: '29'},
          {value: 30, name: '30'},
          {value: 31, name: '31'}
        ],
        optionsOfCreateDialog1Validation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            taskName: {
              required: [true, this.$t('Pm.taskNameNull')],
              regex: [/^[^\'\\\"\<\>]+$/, this.$t('Pm.onlyNumAndLetter')],
              maxLength: [60, this.$t('Pm.taskNameOver60')]
            },
            taskDepict: {
              maxLength: [256, this.$t('Pm.taskDespOver256')]
            },
            startTime: {
              required: [true, this.$t('Pm.begTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.begTimeFormatError')]
            },
            endTime: {
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.endTimeFormatError')]
            }
          }
        },
        formObjOfCreateDialog1: ''
      }
    },
    methods: {
      init(){
        this.$axios.post('/lte/ems/pm/noReal/task/getResourceInfo.html').then((response) => {
          this.dataSourceOfNeType = response.data.resultVal;
          this.paramsOfNoRealTaskCreateDialog1.neType = response.data.resultVal[0].neTypeCode;
        });
      },
      onSampleTimeChange(msg) {
        switch(msg.value){
          case 300000:
            this.dataSourceOfReportTime = [];
            this.dataSourceOfReportTime = [
              {cycle: `5${this.$t('Pm.minutes')}`, value: 300000},
              {cycle: `15${this.$t('Pm.minutes')}`, value: 900000},
              {cycle: `30${this.$t('Pm.minutes')}`, value: 1800000},
              {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
              {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
            ];
            this.paramsOfNoRealTaskCreateDialog1.reportTime = 300000;
            break;
          case 900000:
            this.dataSourceOfReportTime = [];
            this.dataSourceOfReportTime = [
              {cycle: `15${this.$t('Pm.minutes')}`, value: 900000},
              {cycle: `30${this.$t('Pm.minutes')}`, value: 1800000},
              {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
              {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
            ];
            this.paramsOfNoRealTaskCreateDialog1.reportTime = 900000;
            break;
          case 1800000:
            this.dataSourceOfReportTime = [];
            this.dataSourceOfReportTime = [
              {cycle: `30${this.$t('Pm.minutes')}`, value: 1800000},
              {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
              {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
            ];
            this.paramsOfNoRealTaskCreateDialog1.reportTime = 1800000;
            break;
          case 3600000:
            this.dataSourceOfReportTime = [];
            this.dataSourceOfReportTime = [
              {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
              {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
            ];
            this.paramsOfNoRealTaskCreateDialog1.reportTime = 3600000;
            break;
          case 86400000:
            this.dataSourceOfReportTime = [
              {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
            ];
            this.paramsOfNoRealTaskCreateDialog1.reportTime = 86400000;
            break;
          default:
            break;
        }
      },

      changeOfMeasurePlan(params) {
        switch (params.value) {
          case '0':
            this.paramsOfNoRealTaskCreateDialog1.day = [];
            this.paramsOfNoRealTaskCreateDialog1.week = [];
            this.weekPlanShow = false;
            this.monthPlanShow = false;
            this.weekDayExistIndexList= [];
            this.weekDayExistValueList= [];
            this.monthDayExistIndexList= [];
            this.monthDayExistValueList= [];
            break;
          case '1':
            this.paramsOfNoRealTaskCreateDialog1.day = [];
            this.weekPlanShow = true;
            this.monthPlanShow = false;
            this.weekDayExistIndexList= [];
            this.weekDayExistValueList= [];
            this.monthDayExistIndexList= [];
            this.monthDayExistValueList= [];
            break;
          case '2':
            this.paramsOfNoRealTaskCreateDialog1.week = [];
            this.weekPlanShow = false;
            this.monthPlanShow = true;
            this.weekDayExistIndexList= [];
            this.weekDayExistValueList= [];
            this.monthDayExistIndexList= [];
            this.monthDayExistValueList= [];
            break;
          default:
        }
      },
      weekPlanClick(weekPlan, index){
        let exit = false;
        if(this.weekDayExistIndexList.includes(index)){
          Array.prototype.contains = function(obj) {
            let i = this.length;
            while(i--){
              if(this[i] == obj){
                return i;
              }
            }
            return false;
          }
          this.weekDayExistIndexList.splice(this.weekDayExistIndexList.contains(index),1);
          // this.weekDayExistValueList.splice(this.weekDayExistValueList.contains(weekPlan),1);
          this.paramsOfNoRealTaskCreateDialog1.week.splice(this.paramsOfNoRealTaskCreateDialog1.week.contains(weekPlan),1);
          exit = true
        }
        if(!exit){
          // this.weekDayExistValueList.push(weekPlan);
          this.paramsOfNoRealTaskCreateDialog1.week.push(weekPlan);
          this.weekDayExistIndexList.push(index);
        }
        return exit;
      },

      monthPlanClick(monthPlan, index){
        let exit = false;
        if(this.monthDayExistIndexList.includes(index)){
          Array.prototype.contains = function(obj) {
            let i = this.length;
            while(i--){
              if(this[i] == obj){
                return i;
              }
            }
            return false;
          }
          this.monthDayExistIndexList.splice(this.monthDayExistIndexList.contains(index),1);
          // this.monthDayExistValueList.splice(this.monthDayExistValueList.contains(monthPlan),1);
          this.paramsOfNoRealTaskCreateDialog1.day.splice(this.paramsOfNoRealTaskCreateDialog1.day.contains(monthPlan),1);
          exit = true
        }
        if(!exit){
          // this.monthDayExistValueList.push(monthPlan);
          this.paramsOfNoRealTaskCreateDialog1.day.push(monthPlan);
          this.monthDayExistIndexList.push(index);
        }
        return exit;
      },

      checkSelectOrNotForWeek(index) {
        if(this.weekDayExistIndexList.includes(index)){
          return true;
        } else {
          return false;
        }
      },

      checkSelectOrNotForMonth(index){
        if(this.monthDayExistIndexList.includes(index)){
          return true;
        } else {
          return false;
        }
      },

      bindValidateOfCreateDialog1() {
        this.formObjOfCreateDialog1 = new FormValidator('#createNoRealTaskDialog1', this.optionsOfCreateDialog1Validation);
      },

      validateOfCreateDialog1() {
        const formStatus = this.formObjOfCreateDialog1.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      },
    },
    mounted() {
      this.bindValidateOfCreateDialog1();
      this.init();
    }
  }
</script>

<style scoped>
  .h-plan-box {
    width: 322px;
    line-height: 32px;
  }

  .h-plan-week {
    padding: 10px;
    margin: 10px 0;
    background: #FFFFFF;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.12);
    border-radius: 2px;
  }

  .h-plan-month {
    padding: 10px;
    margin: 10px 0;
    background: #FFFFFF;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.12);
    border-radius: 2px;
  }

  .h-plan-week span,
  .h-plan-month span {
    display: inline-block;
    width: 40px;
    height: 34px;
    box-sizing: border-box;
    text-align: center;
    margin: 1px;
  }

  .h-plan-week span:hover,
  .h-plan-month span:hover {
    border: solid 1px #1890FF;
    color: #1890FF;
    border-radius: 4px;
  }
  .h-plan-week span.select,
  .h-plan-month span.select {
    border: solid 1px #1890FF;
    background-color: #1890FF;
    color: #ffffff;
    border-radius: 4px;
  }

  .h-dialogContainer .e-radio-wrapper {
    margin-top: 10px;
    margin-right: 26px;
  }
</style>
